export const App = {
    BaseUrl: "https://wx.123hf.cn",
    LoginPage: "/login",
    Identity: true,
    Prefix: "develop",
    WebsiteName: "后台开发模板",
    LayoutHome: "/home",
    Secret: "BZ4@#$%@dxyftZ55&F^mRH#a+@#jJ36WLn=N",
    AuthorizeUrl: "https://wx.123hf.cn/app/wx/authorize"
}